
/**
 * Composition method for moa frames module
 * 
 * Author: Sahil David
 */
 import { onMounted, toRefs } from 'vue';
 import { useStore } from 'vuex';
 
 import { moaAnimations } from './animations';

export function moaFramesComposition (props: any) {
	const store = useStore();
	const { datum } = toRefs(props);

	// Function to highlight active screen
	function enterFrame (frameId: any): void {
		const obj = datum.value.find((_: any) => _.endpointId === frameId);
		const { section, endpointId } = obj;
		if (!section) { return; }

		store.dispatch('axn_updateMoaActiveSection', section);
		store.dispatch('axn_updateMoaActiveFrame', endpointId);
		
		const insideCell = obj['inside-cell'] === 'true';
		store.dispatch('axn_updateMoaInsideCell', insideCell);

		moaAnimations.enter(endpointId);
	}

	// Function to trigger leave frame methods
	function leaveFrame (frameId: any): void {
		moaAnimations.leave(frameId);
	}

	// Frames dimensions
	function applyDimensions () {
		const landscapeAspect = 1.6;
		const minThresholdLandscapeWidth = 1313;
		const minThresholdLandscapeHeight = 700;

		const minSmallThresholdLandscapeWidth = 1024;
		const minSmallThresholdLandscapeHeight = 550;

		const smallPortraitLimit = 700;

		const mainFrame: any = document.querySelector('.js-timeline-container-1');
		const mainFrameWidth: any = document.querySelector('.js-timeline-width-debug-width');
		const mainFrameHeight: any = document.querySelector('.js-timeline-width-debug-height');
		if (!mainFrame) { return; }
		
		mainFrame.classList.remove('res-screen-sm');
		mainFrame.classList.remove('res-screen-xsm');
		mainFrame.classList.remove('res-screen-portrait');
		mainFrame.classList.remove('res-screen-portrait-sm');
		if (window.innerHeight < window.innerWidth) {
			const width = mainFrame.clientHeight * landscapeAspect;

			if (
				width < minThresholdLandscapeWidth || 
				mainFrame.clientHeight < minThresholdLandscapeHeight
			) {
				mainFrame.classList.add('res-screen-sm')
			} 

			if (
				width < minSmallThresholdLandscapeWidth || 
				mainFrame.clientHeight < minSmallThresholdLandscapeHeight
			) {
				mainFrame.classList.add('res-screen-xsm')
			} 
		} else {
			mainFrame.style.width = '';
			mainFrame.classList.add('res-screen-portrait');

			if (window.innerWidth < smallPortraitLimit) {
				mainFrame.classList.add('res-screen-portrait-sm');
			}
		}
		mainFrameWidth.innerHTML = `${mainFrame.clientWidth}px`;
		mainFrameHeight.innerHTML = `${mainFrame.clientHeight}px`;
	}

	// Mounted lifecycle
	onMounted(() => {
		// Dimensions
		applyDimensions();
		window.addEventListener('resize', applyDimensions);
		
		// Observer API
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry: any) => {
				const { target, isIntersecting } = entry;
				if (!target) { return; }

				if (isIntersecting) {
					// Resetting the frame prev. visited
					const frame = document.querySelector('.js-moa-timeline-frame[data-state="visible"]');
					if (frame) {
						frame.setAttribute('data-state', '');

						const frameId = frame.getAttribute('data-frame');
						leaveFrame(frameId);
					}
					
					// Enter into the frame interaction
					target.setAttribute('data-state', 'visible');
					const frameId = target.getAttribute('data-frame');
					enterFrame(frameId);
				}
			});
		}, {
			root: document.querySelector('.js-timeline-window'),
			rootMargin: '0px',
			threshold: 0.5
		});

		// Calling the Observer function 
		const frames = document.querySelectorAll('.js-moa-timeline-frame');
		(frames || []).forEach((frame: Element) => {
			observer.observe(frame);
		});
	});


	return { }
}
